import React from 'react'
import { useLocation } from 'react-router'
import { useAnalyticsClient, CommunityConfig } from '~/service'

export interface PageWithTrackingProps {
  children: React.ReactNode
  config: CommunityConfig
}

export const PageWithTracking = React.memo(
  ({ children, config }: PageWithTrackingProps) => {
    const analytics = useAnalyticsClient()
    const location = useLocation()

    analytics.setCommunity(
      config.communityId,
      config.communityName,
      config.propertyManagerId,
      config.propertyManagerName
    )
    analytics.trackPage(location)

    return children
  }
)
